import { Action, Selector, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { CloseDialog, OpenDialog } from './external-video.actions';
import { patch } from '@ngxs/store/operators';
import { ExternalVideoData, ExternalVideoModel } from './model/external-video-data.model';
import { ExternalVideoDialogFactory } from './service/external-video.factory';
import { ExternalStats } from 'src/app/models/external-stats';
import { ExternalViewStats } from 'src/app/models/external-view-stats';
import { ExternalVideoService } from './service/external-video.service';

export type ExternalVideoStateModel = {
  externalVideoData: ExternalVideoData;
  externalStats: ExternalStats;
  externalViewStats: ExternalViewStats;
  open: boolean;
};

export const initialState: ExternalVideoStateModel = {
  externalVideoData: undefined,
  externalStats: undefined,
  externalViewStats: undefined,
  open: false,
};

@State<ExternalVideoStateModel>({
  name: 'externalVideo',
  defaults: initialState,
})
@Injectable()
export class ExternalVideoState {

  private readonly externalVideoDialogFactory = inject(ExternalVideoDialogFactory);
  private readonly externalVideoService = inject(ExternalVideoService);

  @Selector()
  static open(state: ExternalVideoStateModel): boolean {
    return state.open;
  }

  @Selector()
  static externalVideoData(state: ExternalVideoStateModel): ExternalVideoData {
    return state.externalVideoData;
  }

  @Action(OpenDialog)
  openDialog(context: StateContext<ExternalVideoStateModel>, { externalVideo }: OpenDialog) {
    context.setState(
      patch({
        open: true,
        externalVideoData: this.externalVideoDialogFactory.buildExternalVideoData(externalVideo),
        externalStats: this.externalVideoDialogFactory.buildExternalStats(externalVideo),
        externalViewStats: this.externalVideoDialogFactory.buildExternalViewStats(externalVideo),
      }),
    );
  }

  @Action(CloseDialog)
  closeDialog(context: StateContext<ExternalVideoStateModel>) {
    if (!context.getState().externalVideoData.isFromExternalDb) {
      this.externalVideoService.postExternalEmbeddedLinkStats(context.getState().externalStats).subscribe();
    } else {
      this.externalVideoService.postExternalDatabaseViewStats(context.getState().externalViewStats).subscribe();
    }

    context.setState(initialState);
  }
}
